import React, { useEffect, useState } from 'react';
import { PhoneIcon, CheckIcon, StarIcon, ArrowRightIcon, MenuIcon, XIcon, ShieldCheckIcon, AwardIcon, HeartIcon, HomeIcon } from 'lucide-react';
import { CashOfferForm } from './CashOfferForm';
export function HeroSection() {
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);
  const navLinks = [{
    label: 'Home',
    href: '#'
  }, {
    label: 'How It Works',
    href: '#how-it-works'
  }, {
    label: 'Where We Buy',
    href: '#where-we-buy'
  }, {
    label: 'About',
    href: '#about'
  }, {
    label: 'FAQ',
    href: '#faq'
  }];
  return <div className="bg-[#0F172A]" data-id="element-150">
      {/* TOP ANNOUNCEMENT BANNER */}
      <div className="bg-[#D4A24C] text-white text-sm md:text-base font-semibold" data-id="element-151">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-center gap-2 text-center" data-id="element-152">
          <PhoneIcon className="w-4 h-4 flex-shrink-0" data-id="element-153" />
          <span data-id="element-154">
            Call Now for a Free Cash Offer — Same-Day Offers Available
            Nationwide
          </span>
        </div>
      </div>

      {/* NAV BAR */}
      <header className="bg-[#0F172A] border-b border-white/5 relative z-30" data-id="element-155">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex items-center justify-between gap-4" data-id="element-156">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2.5 whitespace-nowrap" data-id="element-157">
            <span className="bg-[#D4A24C] text-white p-2 rounded-xl shadow-sm flex items-center justify-center" data-id="element-158">
              <HomeIcon className="w-5 h-5" data-id="element-159" />
            </span>
            <span className="font-display text-white text-2xl md:text-[26px] tracking-wide" data-id="element-160">
              NATIONWIDE <span className="text-[#D4A24C]" data-id="element-161">HOME BUYERS</span>
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-162">
            {navLinks.map(link => <a key={link.label} href={link.href} className="text-white/90 hover:text-[#D4A24C] font-medium text-base transition-colors" data-id="element-163">
                {link.label}
              </a>)}
          </nav>

          {/* Right side */}
          <div className="flex items-center gap-3 md:gap-5" data-id="element-164">
            <a href="tel:+18556052101" className="hidden md:flex items-center gap-2 text-white hover:text-[#D4A24C] transition-colors" data-id="element-165">
              <PhoneIcon className="w-5 h-5 text-[#D4A24C]" data-id="element-166" />
              <span className="font-display text-lg tracking-wider" data-id="element-167">
                1-855-605-2101
              </span>
            </a>
            <button onClick={() => {
            document.getElementById('hero-form')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="hidden sm:inline-flex bg-[#D4A24C] hover:bg-[#B8862F] text-white font-bold uppercase tracking-wider text-sm py-3 px-6 rounded-full transition-colors" data-id="element-168">
              Free Offer
            </button>
            <button onClick={() => setMobileOpen(true)} aria-label="Open menu" className="lg:hidden text-white p-2 -mr-2" data-id="element-169">
              <MenuIcon className="w-6 h-6" data-id="element-170" />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {mobileOpen && <div className="fixed inset-0 z-[100] bg-[#0F172A] lg:hidden" data-id="element-171">
          <div className="flex items-center justify-between px-4 sm:px-6 py-5 border-b border-white/10" data-id="element-172">
            <span className="font-display text-white text-2xl tracking-wide" data-id="element-173">
              <span className="text-[#D4A24C]" data-id="element-174">MENU</span>
            </span>
            <button onClick={() => setMobileOpen(false)} aria-label="Close menu" className="text-white p-2 -mr-2" data-id="element-175">
              <XIcon className="w-7 h-7" data-id="element-176" />
            </button>
          </div>
          <nav className="flex flex-col px-4 sm:px-6 py-8 gap-6" data-id="element-177">
            {navLinks.map(link => <a key={link.label} href={link.href} onClick={() => setMobileOpen(false)} className="text-white text-2xl font-semibold hover:text-[#D4A24C] transition-colors" data-id="element-178">
                {link.label}
              </a>)}
            <a href="tel:+18556052101" className="mt-4 inline-flex items-center gap-2 text-[#D4A24C] font-display text-2xl tracking-wider" data-id="element-179">
              <PhoneIcon className="w-6 h-6" data-id="element-180" />
              1-855-605-2101
            </a>
          </nav>
        </div>}

      {/* HERO with background image */}
      <section className="relative overflow-hidden" data-id="element-181">
        {/* Background Image + Overlays */}
        <div className="absolute inset-0 z-0" data-id="element-182">
          <img src="https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=2000&q=80" alt="Typical Midwest single-family home" className="w-full h-full object-cover" data-id="element-183" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A]/95 via-[#0F172A]/85 to-[#0F172A]/60" data-id="element-184" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/40 to-transparent" data-id="element-185" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 lg:py-28 relative z-10" data-id="element-186">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center" data-id="element-187">
            {/* Left: Headline & Copy */}
            <div className="lg:col-span-7" data-id="element-188">
              {/* Pill Badge */}
              <div className="inline-flex items-center gap-2 border border-[#D4A24C]/60 bg-[#D4A24C]/10 backdrop-blur-sm text-[#D4A24C] rounded-full px-4 py-1.5 mb-8" data-id="element-189">
                <StarIcon className="w-4 h-4 fill-current" data-id="element-190" />
                <span className="text-xs md:text-sm font-bold uppercase tracking-wider" data-id="element-191">
                  Buying Homes in All 50 States
                </span>
              </div>

              {/* Display Headline */}
              <h1 className="font-display text-white text-5xl sm:text-6xl md:text-7xl lg:text-[84px] leading-[0.95] uppercase mb-8 tracking-tight drop-shadow-[0_2px_12px_rgba(0,0,0,0.4)]" data-id="element-192">
                Top-Rated Cash
                <br data-id="element-193" />
                Home Buyers
                <br data-id="element-194" />
                <span className="text-[#D4A24C]" data-id="element-195">You Can Trust</span>
              </h1>

              {/* Body */}
              <p className="text-white/85 text-lg md:text-xl leading-relaxed max-w-xl mb-10 drop-shadow-[0_1px_4px_rgba(0,0,0,0.3)]" data-id="element-196">
                Sell your house fast for cash — no repairs, no commissions, no
                showings. Get a guaranteed cash offer in 24 hours and close on
                your timeline.
              </p>

              {/* CTAs */}
              <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-197">
                <a href="tel:+18556052101" className="inline-flex items-center justify-center gap-3 bg-[#D4A24C] hover:bg-[#B8862F] text-white font-bold uppercase tracking-wider text-base md:text-lg py-5 px-8 rounded-full transition-colors shadow-lg" data-id="element-198">
                  <PhoneIcon className="w-5 h-5" data-id="element-199" />
                  Call 1-855-605-2101
                </a>
                <button onClick={() => {
                document.getElementById('hero-form')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="inline-flex items-center justify-center gap-3 bg-white/10 hover:bg-white/20 text-white font-bold uppercase tracking-wider text-base md:text-lg py-5 px-8 rounded-full transition-colors border border-white/20 backdrop-blur-md" data-id="element-200">
                  Get My Cash Offer
                  <ArrowRightIcon className="w-5 h-5" data-id="element-201" />
                </button>
              </div>

              {/* Trust checks */}
              <div className="flex flex-wrap items-center gap-x-8 gap-y-4" data-id="element-202">
                {['No Fees or Commissions', 'Sell As-Is', 'Close in 7 Days', 'Nationwide Buyer'].map(item => <div key={item} className="flex items-center gap-2 text-white/90" data-id="element-203">
                    <span className="w-5 h-5 rounded-full border-2 border-[#D4A24C] flex items-center justify-center flex-shrink-0" data-id="element-204">
                      <CheckIcon className="w-3 h-3 text-[#D4A24C]" strokeWidth={3} data-id="element-205" />
                    </span>
                    <span className="text-sm md:text-base font-medium" data-id="element-206">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Right: Inline A2P-Compliant Form */}
            <div className="lg:col-span-5 w-full" id="hero-form" data-id="element-207">
              <div className="bg-white p-6 md:p-8 rounded-3xl shadow-[0_20px_60px_rgba(0,0,0,0.35)] border border-white/20" data-id="element-208">
                <div className="mb-6" data-id="element-209">
                  <div className="inline-flex items-center gap-2 bg-[#D4A24C]/10 text-[#D4A24C] rounded-full px-3 py-1 mb-3" data-id="element-210">
                    <span className="text-[11px] font-bold uppercase tracking-wider" data-id="element-211">
                      Free · No Obligation
                    </span>
                  </div>
                  <h2 className="text-2xl md:text-[26px] font-bold text-[#0F172A] mb-1.5 leading-tight" data-id="element-212">
                    Get Your Free Cash Offer
                  </h2>
                  <p className="text-slate-500 text-sm" data-id="element-213">
                    Takes less than 60 seconds. We'll call within 24 hours.
                  </p>
                </div>
                <CashOfferForm buttonText="Get My Cash Offer" data-id="element-214" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GOLD STATS BAR */}
      <section className="bg-[#D4A24C]" data-id="element-215">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-12" data-id="element-216">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 text-center text-white" data-id="element-217">
            {[{
            value: '500+',
            label: 'Homes Purchased'
          }, {
            value: '24hr',
            label: 'Offer Time'
          }, {
            value: '5★',
            label: 'Avg Rating'
          }, {
            value: '10yr',
            label: 'Buying Homes'
          }].map(stat => <div key={stat.label} data-id="element-218">
                <div className="font-display text-5xl md:text-6xl leading-none mb-2 tracking-tight" data-id="element-219">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm font-bold uppercase tracking-widest opacity-95" data-id="element-220">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* TRUST BADGES ROW */}
      <section className="bg-white border-b border-slate-100" data-id="element-221">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-222">
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4" data-id="element-223">
            {[{
            icon: StarIcon,
            label: 'Google 5★ Rated'
          }, {
            icon: ShieldCheckIcon,
            label: 'BBB Accredited A+'
          }, {
            icon: AwardIcon,
            label: 'Trustpilot Excellent'
          }, {
            icon: HeartIcon,
            label: 'Inc. 5000 Honoree'
          }].map(({
            icon: Icon,
            label
          }) => <div key={label} className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 text-slate-700" data-id="element-224">
                <Icon className="w-4 h-4 text-[#D4A24C]" data-id="element-225" />
                <span className="text-xs md:text-sm font-semibold uppercase tracking-wider" data-id="element-226">
                  {label}
                </span>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}